import { ReactElement } from 'react';
import Label from '../../../../../../common/label/label';
import cn from '../../../../../../utils/classnames';
import MaterialSchoolLabel from '../../components/material-school-label/material-school-label';
import { useCardContext } from '../../contexts/favorites-material-card-context';
import useCard from '../../hooks/use-card';
import { FavoritesMaterialCardVariationProps } from '../../types';
import LeftAside from './components/left-aside/left-aside';
import Main from './components/main/main';
import RightAside from './components/right-aside/right-aside';
import './desktop-list-card.scss';

const DesktopListCard = (props: FavoritesMaterialCardVariationProps): ReactElement => {
    const { item, index, shouldShowFolder, internalPath, hasSchoolLabel, banner, voteButton, ...asideProps } = props;

    const { link, ...card } = useCard({
        item,
        internalPath,
        screen: 'desktop',
        className: cn('list-view', { 'with-school-label': hasSchoolLabel })
    });
    const { cardRef } = useCardContext();

    return (
        <div ref={cardRef} className={cn(card.classNames, { 'no-vote-button': !voteButton })} data-testid={card.testId}>
            {card.label && <Label item={item} />}

            {hasSchoolLabel && <MaterialSchoolLabel />}

            <div className='card-content'>
                <div className='card-media'>
                    <LeftAside item={item} index={index} link={link} imageSize='long-mobile' internalPath={internalPath} />
                    <Main item={item} index={index} link={link} shouldShowFolder={shouldShowFolder} internalPath={internalPath} />
                </div>
            </div>

            <div className='right-section'>
                <RightAside item={item} index={index} internalPath={internalPath} {...asideProps} />
            </div>

            {banner && <div className='card-banner'>{banner}</div>}

            {voteButton && <div className='card-vote'>{voteButton}</div>}
        </div>
    );
};

export default DesktopListCard;
